@let p = person();

<lvr-nav-carousel
	backLabel="Zurück"
	[backLink]="backLink()"
	[carouselElements]="carouselElements()"
	[initialIndex]="currentIndex()"
	(navigation)="onNavigate($event)"
>
</lvr-nav-carousel>

<lvr-heading
	[showEditButton]="canEditInstitutionPersons()"
	[showDeleteButton]="canDeleteInstitutionPersons()"
	[deleteTranslationKey]="'institution.persons.deactivate.deactivate'"
	[disableDeleteButton]="p!.isDeactivated"
	[disableDeleteTranslationKey]="disableDeleteTranslationKey"
	[disableEditButton]="p!.isDeactivated"
	[disableEditTranslationKey]="disableDeleteTranslationKey"
	(editClicked)="openEdit()"
	(deleteClicked)="openDialog()"
>
	{{ 'institution.persons.details.title' | transloco: { name: personName() } }}
</lvr-heading>

<section class="grid">
	<table>
		<!-- Kategorie / Zweigstellen -->
		<tr>
			<th scope="col">{{ 'institution.persons.details.category' | transloco }}</th>
			<th scope="col">{{ 'institution.persons.details.workplaces' | transloco }}</th>
		</tr>
		<tr>
			<td>{{ p?.personType?.name }}</td>
			<td>
				<ul>
					@for (branch of p?.responsibleBranches; track branch.id) {
						<li>{{ branch.name }}</li>
					}
				</ul>
			</td>
		</tr>

		<!-- Nachname / Vorname -->
		<tr>
			<th scope="col">{{ 'institution.persons.details.name' | transloco }}</th>
			<th scope="col">{{ 'institution.persons.details.first_name' | transloco }}</th>
		</tr>
		<tr>
			<td>{{ p?.name }}</td>
			<td>{{ p?.firstName }}</td>
		</tr>

		<!-- Geschlecht / Titel -->
		<tr>
			<th scope="col">{{ 'institution.persons.details.gender' | transloco }}</th>
			<th scope="col">{{ 'institution.persons.details.person_title' | transloco }}</th>
		</tr>
		<tr>
			<td>{{ p?.gender?.salutation }}</td>
			<td>{{ p?.title }}</td>
		</tr>

		<!-- Adresse / Bemerkung -->
		<tr>
			<th scope="col">{{ 'institution.persons.details.address' | transloco }}</th>
			<th scope="col">{{ 'institution.persons.details.remark' | transloco }}</th>
		</tr>
		<tr>
			<td>
				{{ p?.address?.streetAndHouseNumber }}<br />
				{{ p?.address?.postalCodeAndCity }}
			</td>
			<td>{{ p?.remark }}</td>
		</tr>

		<!-- Kommunikationswege -->
		<tr>
			<th scope="col">{{ 'institution.persons.details.preferred_communication' | transloco }}</th>
			<th scope="col">{{ 'institution.persons.details.other_communication' | transloco }}</th>
		</tr>
		<tr>
			<td>
				<ul>
					@for (cp of preferredCommunicationPoints(); track cp.id) {
						@if (cp.categoryContactPointId === contactTypes.phone) {
							<li>
								<a [href]="'tel:' + cp.contactValue">{{ cp.contactValue }}</a>
								<p>{{ cp.remark }}</p>
							</li>
						} @else if (cp.categoryContactPointId === contactTypes.email) {
							<li>
								<a [href]="'mailto:' + cp.contactValue">{{ cp.contactValue }}</a>
								<p>{{ cp.remark }}</p>
							</li>
						}
					}
				</ul>
			</td>
			<td>
				<ul>
					@for (cp of otherCommunicationPoints(); track cp.id) {
						@if (cp.categoryContactPointId === contactTypes.phone) {
							<li>
								<a [href]="'tel:' + cp.contactValue">{{ cp.contactValue }}</a>
								<p>{{ cp.remark }}</p>
							</li>
						} @else if (cp.categoryContactPointId === contactTypes.email) {
							<li>
								<a [href]="'mailto:' + cp.contactValue">{{ cp.contactValue }}</a>
								<p>{{ cp.remark }}</p>
							</li>
						}
					}
				</ul>
			</td>
		</tr>

		<!-- Datenschutz clarification -->
		<tr>
			<th scope="col" colspan="2">{{ 'institution.persons.details.privacy_clarification' | transloco }}</th>
		</tr>
		<tr>
			<td colspan="2">
				{{
					p?.hasBeenClarified
						? ('institution.persons.details.true' | transloco)
						: ('institution.persons.details.false' | transloco)
				}}<br />
				{{ p?.clarifiedAt | date: 'dd.MM.yyyy' }}<br />
				{{ getClarificationLabel(p?.typeOfClarification) | transloco }}
			</td>
		</tr>
	</table>
</section>
